import { flattenMessages } from '../../helpers';

import enGlobal from '../global/en.json';
import esGlobal from '../global/es.json';
import ruGlobal from '../global/ru.json';
import zhGlobal from '../global/zh.json';

import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: {
    ...flattenMessages(en, 'vote'),
    ...flattenMessages(enGlobal, 'global'),
  },
  es: {
    ...flattenMessages(es, 'vote'),
    ...flattenMessages(esGlobal, 'global'),
  },
  ru: {
    ...flattenMessages(ru, 'vote'),
    ...flattenMessages(ruGlobal, 'global'),
  },
  zh: {
    ...flattenMessages(zh, 'vote'),
    ...flattenMessages(zhGlobal, 'global'),
  },
};
